/* eslint eqeqeq: 0 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Header from './pages/header';
import Pengaturan from './pages/components/pengaturan';
import Login from './pages/login';
function Cekstatustoken(komponen) {
  const history = useHistory();
  const [loged, setLoged]=useState(true);
  let Cmp=komponen.Cmp;
  const token = localStorage.getItem("token");
  const fetchData = async () =>{    
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      await axios.get(Pengaturan['urlApi']+'user')
      .then((response)=>{
        setLoged(true);    
      })
      .catch((error)=> {
          setLoged(false);
          if(error.response.status == '401'){
            setLoged(false);          
            clearLocal();
            history.push(Pengaturan['baseurl']);
          }
      });
  }
  useEffect(()=>{
    if(token){
      fetchData();      
    }else{         
      clearLocal();
      setLoged(false);
      console.log('loged out');
      history.push(Pengaturan['baseurl']);
    }
  },[]);
  const clearLocal=()=>{
    localStorage.removeItem("rtr");
    localStorage.removeItem("router");                  
    localStorage.removeItem("token");
    localStorage.removeItem("title");
    localStorage.removeItem("alamat");
  }
  
    if(loged){return(<><Header /><Cmp /></>)}
    else{return(<><Login /></>)}
  
}
export default Cekstatustoken;